/* eslint-disable no-shadow  */
/* eslint-disable prefer-rest-params  */
/* eslint-disable no-underscore-dangle  */
/* eslint-disable no-param-reassign  */
/* eslint-disable no-plusplus  */
/* eslint-disable no-multi-assign  */

import { IProductDetail } from '@/storePinia/stores/product/interfaces/IProductDetail';
import { useResultsStore } from '@/storePinia/stores/results';
import { IOrderProduct } from '@/storePinia/stores/basket/interfaces/IBasket';
import { TIKTOK_PIXEL_ID } from '@/settings/keys';
import { getExistingPiniaStore } from '@/storePinia';
import { ICheckout } from '@/storePinia/stores/checkout/interfaces/ICheckout';

// eslint-disable-next-line no-use-before-define
let instance: TikTokPixel | null = null;

type IProductWithCount = IProductDetail & { count: number };

interface IGeneralData {
  currency: string;
  // eslint-disable-next-line camelcase
  transaction_id: string;
  shipping: string;
  value: string;
  affiliation: string;
}

export class TikTokPixel {
  private pixelId: string;

  public ready: Promise<void>;

  private static initialized = false;

  private constructor(pixelId: string) {
    this.pixelId = pixelId;

    this.ready = new Promise((resolve) => {
      this.init(resolve);
    });
  }

  /**
   * Ініціалізуємо singleton (викликаємо один раз у main.ts)
   */
  static init(pixelId: string = TIKTOK_PIXEL_ID || '') {
    if (!instance) {
      instance = new TikTokPixel(pixelId);
    }
    return instance;
  }

  /**
   * Отримати вже ініціалізований інстанс (у компонентах/композаблах)
   */
  static getInstance() {
    if (!instance) {
      throw new Error('TikTokPixel не ініціалізований. Виклич init() у main.ts');
    }
    return instance;
  }

  private init(resolve: () => void) {
    if (TikTokPixel.initialized) {
      // уже ініціалізовано — просто резолвимо
      if (window.ttq && window.ttq.ready) {
        window.ttq.ready(() => resolve());
      } else {
        resolve();
      }
      return;
    }

    (function (w: any, d: Document, t: string) {
      if (w[t]) return; // щоб не переоголосити, якщо щось уже є

      w.TiktokAnalyticsObject = t;
      const ttq: any = (w[t] = w[t] || []);
      ttq.methods = [
        'page',
        'track',
        'identify',
        'instances',
        'debug',
        'on',
        'off',
        'once',
        'ready',
        'alias',
        'group',
        'enableCookie',
        'disableCookie',
      ];
      ttq.setAndDefer = function (t: any, e: string) {
        t[e] = function () {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      };
      for (let i = 0; i < ttq.methods.length; i++) {
        ttq.setAndDefer(ttq, ttq.methods[i]);
      }

      ttq.instance = function (t: string) {
        const e = ttq._i[t] || [];
        for (let n = 0; n < ttq.methods.length; n++) {
          ttq.setAndDefer(e, ttq.methods[n]);
        }
        return e;
      };

      ttq.load = function (e: string, n?: any) {
        const i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
        ttq._i = ttq._i || {};
        ttq._i[e] = [];
        ttq._i[e]._u = i;
        ttq._t = ttq._t || {};
        ttq._t[e] = +new Date();
        ttq._o = ttq._o || {};
        ttq._o[e] = n || {};

        const o = d.createElement('script');
        o.type = 'text/javascript';
        o.async = true;
        o.src = `${i}?sdkid=${e}&lib=${t}`;

        const a = d.getElementsByTagName('script')[0];

        a.parentNode?.insertBefore(o, a);
      };
    })(window as any, document, 'ttq');

    // Part 2
    // window.ttq.debug(true);
    const alreadyLoaded = Boolean(window.ttq?._i?.[this.pixelId]);

    if (!alreadyLoaded) {
      window.ttq.load(this.pixelId);
      window.ttq.page();
    }

    if (window.ttq.ready) {
      window.ttq.ready(() => {
        resolve();
      });
    } else {
      resolve();
    }

    TikTokPixel.initialized = true;
  }

  // Зручні методи
  track(eventName: string, data: Record<string, any> = {}) {
    // console.log(eventName, data);
    window.ttq.track(eventName, data);
  }

  formData(product: IProductDetail) {
    const { dataLayerProduct } = product;

    return {
      content_type: 'product',
      content_ids: [dataLayerProduct.id], // масив
      contents: [
        {
          content_id: dataLayerProduct.id,
          content_name: dataLayerProduct.name,
          content_type: 'product',
          quantity: 1,
          price: dataLayerProduct.price,
        },
      ],
      value: dataLayerProduct.price,
      currency: product.price.currency,
    };
  }

  page(data: Record<string, any> = {}) {
    window.ttq.page(data);
  }

  // methods
  viewProduct(product: IProductDetail) {
    this.track('ViewContent', this.formData(product));
  }

  addToCart(product: IProductDetail) {
    this.track('AddToCart', this.formData(product));
  }

  addToWishlist(product: IProductDetail) {
    this.track('AddToWishlist', this.formData(product));
  }

  initiateCheckout(items: IProductWithCount[]) {
    const checkoutStore = getExistingPiniaStore<ICheckout>('checkout');
    const resultStore = useResultsStore();

    const contents = items.map((el) => ({
      content_id: el.dataLayerProduct.id,
      content_name: el.dataLayerProduct.name,
      content_type: 'product',
      quantity: el.count ?? 1,
      price: el.dataLayerProduct.price,
    }));

    this.track('InitiateCheckout', {
      content_type: 'product',
      content_ids: contents.map((c) => c.content_id),
      contents,
      value: checkoutStore?.vue?.basketPrice?.totalPrice,
      currency: resultStore.getCurrency,
    });
  }

  // addPaymentInfo() {
  // this.track('AddPaymentInfo', {
  // contents: checkout.items.map((item) => ({
  //   content_ids: item.id,
  //   quantity: item.quantity,
  //   price: item.price,
  // })),
  // value: checkout.total,
  // currency: 'UAH',
  // });
  // }

  purchase(generalData: IGeneralData, items: Array<IOrderProduct>) {
    const contents = items.map((item) => ({
      content_id: item.id,
      content_type: 'product',
      quantity: item.count ?? 1,
      price: Number(item.dataLayerProduct?.price ?? 0),
    }));

    this.track('Purchase', {
      content_type: 'product',
      content_ids: contents.map((c) => c.content_id),
      contents,
      order_id: generalData.transaction_id,
      value: Number(generalData.value),
      currency: generalData.currency,
    });
  }
}
